var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0C62.5892 0 80.5 17.9077 80.5 40C80.5 62.0923 62.5892 80 40.5 80C18.4077 80 0.5 62.0923 0.5 40C0.5 17.9077 18.4077 0 40.5 0Z",
    fill: "#69D85F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.323 25.5109L60.8793 23.0659C60.2859 22.497 59.4901 22.1863 58.6668 22.2017C57.8436 22.2172 57.0601 22.5577 56.4887 23.1484C50.7208 29.3384 35.333 45.7521 34.7428 45.7521C34.1526 45.7521 28.5297 39.8923 25.361 36.5497C24.7876 35.9681 24.007 35.6353 23.1888 35.6237C22.3706 35.6122 21.5809 35.9227 20.9911 36.4878L18.568 38.9226C18.0172 39.4982 17.71 40.2629 17.71 41.0581C17.71 41.8533 18.0172 42.618 18.568 43.1937L32.5682 57.5647C32.857 57.8548 33.2006 58.0851 33.5791 58.2422C33.9577 58.3993 34.3637 58.4802 34.7738 58.4802C35.184 58.4802 35.59 58.3993 35.9685 58.2422C36.3471 58.0851 36.6907 57.8548 36.9795 57.5647L63.3852 29.751C63.9329 29.1763 64.2329 28.4108 64.2213 27.6184C64.2096 26.8259 63.8875 26.0695 63.323 25.5109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck2);
export default __webpack_public_path__ + "static/media/icon-check-2.945ba5b1b662c1ae7b58448e9bb79238.svg";
export { ForwardRef as ReactComponent };